import { render, staticRenderFns } from "./TextModerationServer.vue?vue&type=template&id=061b8ff4&"
import script from "./TextModerationServer.vue?vue&type=script&lang=js&"
export * from "./TextModerationServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports